import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-calibration",
  "use": "icon-soc-calibration-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-calibration\">\r\n  <g fill=\"currentColor\">\r\n    <path d=\"M192 736h640v64H192z\" />\r\n    <path d=\"M288 320h64v416h-64zM480 224h64v512h-64zM672 416h64v320h-64z\" />\r\n    <circle cx=\"320\" cy=\"288\" r=\"48\" />\r\n    <circle cx=\"512\" cy=\"192\" r=\"48\" />\r\n    <circle cx=\"704\" cy=\"384\" r=\"48\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-calibration.svg
// module id = +8K1
// module chunks = 491